import React from 'react';
import '../../assets/css/UC/catalogInformation.scss';

import { useTranslation } from "../../contexts/TranslationContext";

export default function CatalogInformation({ info, arrAccounts, layout = 'single-column' }) {

    const { language } = useTranslation();

    const details = language.details || {};

    const defaultUnknownValue = details.defaultUnknownValue || 'N/A';

    return (
        <div className="info-section catalog-information">
            <h4>{details.productInformation || 'Product Information'}</h4>

            <div className={`info-grid ${layout}`}>
                {/* First column items */}
                <div className="info-column">
                    <div className="info-item">
                        <label>{details.make || 'Make'}</label>
                        <span>{info.Make || defaultUnknownValue}</span>
                    </div>

                    <div className="info-item">
                        <label>{details.shoeType || 'Shoe Type'}</label>
                        <span>{info.ShoeType || defaultUnknownValue}</span>
                    </div>

                    <div className="info-item">
                        <label>{details.model || 'Model'}</label>
                        <span>{info.Model || defaultUnknownValue}</span>
                    </div>

                    <div className="info-item">
                        <label>{details.productID || 'Product ID'}</label>
                        <span>{info.ProductCode || defaultUnknownValue}</span>
                    </div>
                </div>

                {/* Second column items */}
                <div className="info-column">
                    <div className="info-item">
                        <label>{details.color || 'Color'}</label>
                        <span>{info.Colors || defaultUnknownValue}</span>
                    </div>

                    <div className="info-item reference-link">
                        <label>{details.referenceLink || 'Reference Link'}</label>
                        <a href="#" onClick={() => { window.open(`${info.ReferenceLink}`) }}>{info.ReferenceLink || defaultUnknownValue}</a>
                    </div>

                    <div className="info-item">
                        <label>{details.datetimeUpload || 'Upload Date'}</label>
                        <span>{info.UploadedTimeValue ? `${info.UploadedTimeValue} (GMT)` : defaultUnknownValue}</span>
                    </div>

                    <div className="info-item">
                        <label>{details.datetimeUpdate || 'Update Date'}</label>
                        <span>{info.UpdatedTimeValue ? `${info.UpdatedTimeValue} (GMT)` : defaultUnknownValue}</span>
                    </div>
                </div>
            </div>
        </div>
    );
}